export const LOGIN_USER = "LOGIN_USER"
export const REGISTER_USER = "REGISTER_USER"
export const AUTH_USER = "AUTH_USER"
export const LOGOUT_USER = "LOGOUT_USER"

//PRODUCTS TYPES
export const GET_PRODUCTS_BY_ARRIVAL = "GET_PRODUCTS_BY_ARRIVAL"
export const GET_PRODUCTS_BY_SELL = "GET_PRODUCTS_BY_SELL"
export const GET_BRANDS = "GET_BRANDS"
export const GET_STYLES = "GET_STYLES"
export const ADD_BRAND = "ADD_BRAND"
export const ADD_STYLE = "ADD_STYLE"
export const GET_PRODUCTS_TO_SHOP = "GET_PRODUCTS_TO_SHOP"
export const ADD_PRODUCT = "ADD_PRODUCT"
export const CLEAR_ADDED_PRODUCT = "CLEAR_ADDED_PRODUCT"
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL"
export const CLEAR_PRODUCT_DETAIL = "CLEAR_PRODUCT_DETAIL"

//Cart types
export const ADD_TO_CART_USER = "ADD_TO_CART_USER"
export const GET_CART_ITEMS_USER = "GET_CART_ITEMS_USER"
export const REMOVE_CART_ITEM_USER = "REMOVE_CART_ITEM_USER"
export const ON_SUCCESS_BUY_USER = "ON_SUCCESS_BUY_USER"
//update user info
export const UPDATE_DATA_USER = "UPDATE_DATA_USER"
export const CLEAR_UPDATE_DATA_USER = "CLEAR_UPDATE_DATA_USER"
//Site Info types
export const GET_SITE_INFO = "GET_SITE_INFO"
export const UPDATE_SITE_INFO = "UPDATE_SITE_INFO"




